import { useQueryClient } from '@tanstack/react-query';

import { appStorage } from '@sternum/web/services/appStorage';
import { trpc, TRPCReactQueryOptions } from '@sternum/web/services/trpc';

import { useRedirectToDefaultPath } from '../useRedirectToDefaultPath';

export function useSubmitMFA(options?: TRPCReactQueryOptions['auth']['mfaAuthentication']) {
  const queryClient = useQueryClient();
  const { redirectToDefaultPath } = useRedirectToDefaultPath();

  return trpc.auth.mfaAuthentication.useMutation({
    async onSuccess(response) {
      appStorage.setToken(response.token);

      queryClient.invalidateQueries();

      await redirectToDefaultPath(response.clientId);
    },
    ...options,
  });
}
